// @flow
import React from 'react';
import styled from 'styled-components';
import { Button } from '@finect/tabular-core/Button';
import { Small } from '@finect/tabular-core/Small';

const CTAWrapper = styled.div`
  width: 100%;
  margin: 40px auto;
  text-align: center;
`;

type Props = {
  toggleModal?: () => void,
  targetId?: string
};

/**
 * CTA de captación dentro de un artículo.
 *
 * Por defecto abre el modal de la píldora (`toggleModal`). Si se pasa `targetId`, el botón
 * hace scroll suave hasta la píldora inline con ese id (patrón usado en `/saber`); si no
 * encuentra el nodo, cae al modal.
 */
export const ArticleCTA = ({ toggleModal, targetId }: Props) => {
  const handleClick = () => {
    if (targetId && typeof document !== 'undefined') {
      const target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
    if (toggleModal) toggleModal();
  };

  return (
    <CTAWrapper>
      <Button width="auto" onClick={handleClick}>
        Buscar mi asesor financiero
      </Button>
      <Small display="block" margin="8px 0 0" textAlign="center" light>
        Gratis · Sin compromiso · Propuestas personalizadas
      </Small>
    </CTAWrapper>
  );
};
